declare namespace $ {

	export class $bog_card_tag extends $mol_text {
	}
	
}

//# sourceMappingURL=tag.view.tree.d.ts.map